import { render } from "./sections-form.vue?vue&type=template&id=3ee1c368"
import script from "./sections-form.vue?vue&type=script&lang=js"
export * from "./sections-form.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__